<template>
    <div class="custom-field-group">
        <h4 v-if="fieldGroup.title">
            {{ fieldGroup.title }}
        </h4>
        <h5 v-if="fieldGroup.subtitle">
            {{ fieldGroup.subtitle }}
        </h5>
        <FieldInstancesForm mode="edit"
                            :instances="fieldGroup.instances" />
    </div>
</template>

<script>
import FieldInstancesForm from '@/vue/components/CustomFields/FieldInstancesForm';

export default {
    components: { FieldInstancesForm },

    props: {
        /**
         * @type {FieldGroup}
         */
        fieldGroup: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../less/variables";

.custom-field-group {
    background: @white;
    border-radius: @border-radius-base;
    border: 1px solid @btn-default-border;
    box-shadow: 0 3px 8px -9px black;

    margin: 0;
    padding: @gutter-width;

    &:not(:first-child) {
        margin-top: @gutter-width;
    }

    // Field group title.
    h4 {
        font-weight: bold;
        margin: 0;
        color: @dark-grey;
    }

    // Field group subtitle.
    h5 {
        margin: 2px 0 0 0;
        color: @dark-grey;
    }
}
</style>
